import { BUTTON_HEIGHT, FONT_SIZE, TEXT_SCALE_PROPS } from "@lhd/constants";
import { DISPLAY_SIZES } from "@lhd/types";
import "@silevis/reactgrid/styles.css";
import styled from "styled-components";

export const Styles = styled.div`
  width: 100%;
  .reactgrid {
    height: auto !important;
  }

  .ignore-sticky-top {
    .reactgrid-content .rg-pane.rg-pane-top {
      z-index: 2;
    }
  }
  &.second-table-police-mode {
    .ignore-sticky-top {
      .reactgrid-content .rg-pane.rg-pane-top {
        z-index: 2;
      }
    }
  }
  .rg-container {
    width: 100%;
  }

  .rg-cell {
    white-space: normal !important;
    word-break: break-word !important;
    overflow: visible;
    align-items: flex-start !important;
    font-weight: 400 !important;

    &[data-cell-rowidx="0"] {
      background-color: #e8e8e8 !important;
      border: 0.5px solid rgb(217, 217, 217);
    }
    &[data-cell-colidx="0"] {
      background-color: #eefaff !important;
    }
  }

  .rg-cell[data-cell-rowidx="0"] {
    align-items: center !important;
  }

  .rg-header-cell,
  .rg-headerIcon-cell {
    align-items: center !important;
  }

  /* Custom context menu panel (ReactGrid) */
  .reactgrid-content .rg-context-menu {
    min-width: 220px;
    padding: 6px 0;
    border-radius: 8px;
    border: 1px solid rgba(0, 0, 0, 0.08);
    box-shadow: 0 6px 16px 0 rgba(0, 0, 0, 0.08),
      0 3px 6px -4px rgba(0, 0, 0, 0.12), 0 9px 28px 8px rgba(0, 0, 0, 0.05);
    z-index: 1050;
    max-height: min(70vh, 360px);
    overflow-y: auto;
    overflow-x: hidden;
    box-sizing: border-box;
  }

  .reactgrid-content .rg-context-menu .rg-context-menu-option {
    padding: 10px 16px;
    margin: 0 6px;
    border-radius: 6px;
    font-size: 14px;
    line-height: 1.4;
    cursor: pointer;
    transition: background-color 0.15s ease;
  }

  .reactgrid-content .rg-context-menu .rg-context-menu-option:hover {
    background-color: #e6f4ff;
  }

  .rg-richTextCellTemPlate-celleditor {
    padding: 0 !important;
  }
`;

export const StyledBtn = styled.div<TEXT_SCALE_PROPS>`
  .ant-btn {
    font-size: ${({ text_scale }) =>
      FONT_SIZE[text_scale || DISPLAY_SIZES.SMALL]} !important;

    height: ${({ text_scale }) =>
      `${BUTTON_HEIGHT[text_scale ?? DISPLAY_SIZES.SMALL]}px`} !important;
  }
`;
